
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('g',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"m3.5 3 4 5-4 5"}}),_vm._v(" "),_c('path',{attrs:{"d":"m8.5 3 4 5-4 5"}})])])}
var staticRenderFns = []

    export default {
      render: render,
    }
  